import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class OfferCollection extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }
    var slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 1
    };
    let heroImage = null;
    let heroImageUrl = '';
    heroImageUrl =
      pagedetails.heroBanner.imageUrl.indexOf('?') == -1
        ? pagedetails.heroBanner.imageUrl
        : pagedetails.heroBanner.imageUrl.substr(0, pagedetails.heroBanner.imageUrl.indexOf('?'));
    heroImage = (
      <div className="hero-image">
        <a
          href={pagedetails.heroBanner.bannerUrlLink}
          data-ga-event-category="bannerTap"
          data-ga-event-action={`${sectionName}/${pagedetails.heroBanner.componentPosition}/${widgetType}`}
          data-ga-event-label={`${heroImageUrl}/${pagedetails.heroBanner.bannerPosition}`}
          data-gtm-bnr-position={`${pagedetails.heroBanner.componentPosition}`}
          data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(pagedetails.heroBanner.imageUrl) ||
            ''}`}
          data-gtm-bnr-id={`${pagedetails.heroBanner.uId || ''}`}
        >
          <img src={`${replaceWithJioCDN(pagedetails.heroBanner.imageUrl)}`} />
        </a>
      </div>
    );

    var arr = [];
    bannerDetail.map((bannerimagedetails, j) => {
      arr.push({
        id: j,
        uId: bannerimagedetails.uId,
        imageUrl: bannerimagedetails.imageUrl,
        urlLink: bannerimagedetails.bannerUrlLink,
        bannerPos: bannerimagedetails.bannerPosition,
        componentPos: bannerimagedetails.componentPosition
      });
    });

    let imageGallery = arr.map((data, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        data.imageUrl.indexOf('?') == -1
          ? data.imageUrl
          : data.imageUrl.substr(0, data.imageUrl.indexOf('?'));
      return (
        <Col xs={2} key={i} className="gallery-section">
          <a
            href={data.urlLink}
            className="img-animate"
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${data.componentPos}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${data.bannerPos}`}
            data-gtm-bnr-position={`${data.componentPos}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(data.imageUrl) || ''}`}
            data-gtm-bnr-id={`${data.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(data.imageUrl)}`} />
          </a>
        </Col>
      );
    });

    let imageList;

    if (arr.length > 2) {
      imageList = (
        <Slider {...slickSettings} ref="slick">
          {imageGallery}
        </Slider>
      );
    } else {
      imageList = imageGallery;
    }
    const classNames = `gallery-cont${arr.length <= 2 ? ' row' : ''}`;

    return (
      <div className="gallery-com">
        <div className="overlap-gallery">
          {heroImage}
          <div className={classNames}>{imageGallery}</div>
        </div>
      </div>
    );
  }
}

export default BannerWrapper(OfferCollection);
